import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationAConstants {
    static REMOVE_ADVERTISEMENT_LABEL = "Remove advertisement";
    static DESCRIPTION_LABEL_1 = "Search the map to find the advertisement for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct advertisement and click on the advertisement. Click on 'add advertisement' in the window that appears on the map after you selected the advertisement.";
    static DESCRIPTION_LABEL_3 = "The advertisement will be added and the fields must be completed for the advertisement.";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL = "Is the advertising permanent or temporary?";
    static APPLICATION_TYPE_LABEL = "Application type";
    static FEATURE_REQUIRED = "Please select an advertisement type and a feature on the map before saving or continuing with the application process";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static ADVERTISEMENT_FORM_GROUP_NAME = "advertisementsForm";
    static ADVERTISEMENT_FORM_CONTROL_NAME = "advertisements";
    static AREA_OF_DISPLAY_FORM_CONTROL_NAME = "areaOfDisplay";
    static IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME = "isAdvetisingPermanentOrTemporary";
    static STREET_NAMES_FORM_CONTROL = "streetNames";
    static PROPERTY_DESCRIPTION_FORM_CONTROL_NAME = "propertyDescription";
    static ADDRESS_OR_STREET_FORM_CONTROL_NAME = "addressStreetInformation";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static AREA_OF_CONTROL_LABEL = "Area of control";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static STREET_NAMES_LABEL = "Street names";
    static PROPERTY_DESCRIPTION_LABEL = "Property description (If it is a private sale or permanent advertisement)";
    static ADDRESS_OR_STREET_LABEL = "Address / Street information";
    static LAYER_REFERENCE = "Advertising graphics";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static MODAL_DIALOG_TITLE = "Are you sure you want to change the advertisement type";
    static MODAL_DIALOG_MESSAGE = "Changing the advertisement type will erase all the information that has already been captured in the location details. Do you want to continue changing the advertisement type?";
    static VALIDATION_MESSAGES = {
        areaOfDisplay: {
            required: `Area of control ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, streetNames: {
            required: `Street names ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, propertyDescription: {
            required: `Property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, addressOrStreet: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, isAdvertisingPermanentOrTemporary: {
            required: `is advertising permanent or temporary ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static PERMANENT_OR_TEMPORARY_LOOKUPS_A = [{ code: "permanent", value: "permanent" }, { code: "temporary", value: "temporary" }];
    static POLYGON_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            point: false, circle: false, polyline: false, rectangle: false
        }, selectionTools: {
            "lasso-selection": false, "rectangle-selection": false
        }
    };
    static POINT_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            circle: false, polygon: false, polyline: false, rectangle: false
        }, selectionTools: {
            "lasso-selection": false, "rectangle-selection": false
        }
    };
    static MODAL_OPTIONS = {
        size: "xl",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
}
